/**
 * "When" on a notification, in the mock's words (notifications-mock):
 * "40 min ago", "3 hours ago", "Today 7:05 AM", "Yesterday", "Mon 6:00 AM",
 * "Oct 2". Local time of the reader. `iso` is the time the source reported
 * the event (`sourceAt`), never the time we stored it.
 */
const MIN = 60_000;
const HOUR = 60 * MIN;

const time = (d: Date) => d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
const dayStart = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

export function notificationWhen(iso: string, now: Date = new Date()): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const ago = now.getTime() - d.getTime();
  if (ago < MIN) return "Just now";
  if (ago < HOUR) return `${Math.floor(ago / MIN)} min ago`;
  const days = Math.round((dayStart(now) - dayStart(d)) / (24 * HOUR));
  if (days === 0) {
    if (ago < 6 * HOUR) {
      const h = Math.floor(ago / HOUR);
      return h === 1 ? "1 hour ago" : `${h} hours ago`;
    }
    return `Today ${time(d)}`;
  }
  if (days === 1) return "Yesterday";
  if (days < 7) return `${d.toLocaleDateString("en-US", { weekday: "short" })} ${time(d)}`;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
